<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-4 col-lg-offset-4 mb-5 mt-5">
      <mat-card class="mat-elevation-z8" id="card">
        <div class="text-left go-back d-block">
          <div class="asset-create-controls-wrapper">
            <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
              <mat-icon matPreffix>arrow_back_ios</mat-icon>
              Go Back
            </button>
            <button
              (click)="navigateToBulkMode()"
              disableRipple
              mat-button
              class="delete-user p-0"
              *ngIf="currentUser.hasRight(['admin', 'manager'])"
            >
              Bulk upload
              <mat-icon matPreffix>backup</mat-icon>
            </button>
          </div>
          <h6 class="text-center card-title-page">Create New Asset:</h6>
        </div>
        <div *ngIf="isFormVisible()" class="row d-flex justify-content-center">
          <div class="col-12 col-sm-9 col-sm-offset-1 mt-4">
            <app-dynamic-form [questions]="questions" (hasChanged)="onChange($event)" (formSubmit)="onSubmit($event)">
            </app-dynamic-form>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
